import React, { useState } from "react";
import './Document.css';

/**
 * creates container for document
 * @param {*} documents - all document files associated with video
 * @param {*} tabDisplay - displays either documents or agendas
 * @param {*} hasAgenda - if video has agendas associated with it
 * @param {*} changeDisplay - function that changes display based on what tab
 *                            is selected. (Agenda or Document) 
 * @returns container of document
 */
const Document = ({ 
  documents, 
  tabDisplay, 
  hasAgenda,
  changeDisplay,
}) => {

  const [doc, setDoc] = useState(documents[0]['filePath']);

  // change doc
  const handleChange = (event) => {
    event.preventDefault();
    let { value } = event.target;
    setDoc(value);
  };

  return (
    <div className='document-style'>
      <div className='document-container'>
        {hasAgenda ? 
        <div 
          style={{ 
            display: 'flex', 
            flexDirection: 'row', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            width: '11.5rem',
            marginBottom: '1.5%',
          }}
        >
            <button 
              name='document'
              className='document-container-btn'
              style={{
                color: tabDisplay === 'document' ? 'white' : 'black',
                backgroundColor: tabDisplay === 'document' ? 
                                 'rgb(33, 150, 243)' : 'rgb(238, 238, 238)'
              }}
              onClick={(event) => changeDisplay(event.target.name)}
            >
              Document
            </button>
            <button
              name='agenda'
              className='document-container-btn'
              style={{
                color: tabDisplay === 'agenda' ? 'white' : 'black',
                backgroundColor: tabDisplay === 'agenda' ? 
                                 'rgb(33, 150, 243)' : 'rgb(238, 238, 238)'

              }}
              onClick={(event) => changeDisplay(event.target.name)}
            >
              Agenda
            </button>
        </div> : null}
        {tabDisplay === 'document' ?
          <select 
            className='doc-select'
            style={{ 
              width: '50%',                  
              backgroundColor: 'rgb(238, 238, 238)',
              boxShadow: '4px 4px 4px rgba(0, 0, 0, 0.25)',
            }}
            onChange = {(e) => handleChange(e)}
          >
            {documents.map((entry, index)=> (
                <option
                  key={index}
                  style={{ color: 'red' }}
                  value={entry.filePath}
                >
                {entry.name}
              </option>
            ))}
          </select>
        : null}
      </div>
      {tabDisplay === 'document' ? <>
        <iframe
          className="document-iframe dt" 
          src={doc}
          type="application/pdf"
        >
        </iframe>
        <a href = {doc} download>Download File</a>
      </> : null}
    </div>
  )
}

export default Document;
